import React from "react";
import { Heart, ThumbsUp, ThumbsDown, Circle, Play, Sparkle } from "lucide-react";

// Lucide icons are outlines; these are the filled variants (selected states, status dots).
const filled = (Icon) => (props) => <Icon fill="currentColor" {...props} />;

export const HeartFilled = filled(Heart);
export const ThumbsUpFilled = filled(ThumbsUp);
export const ThumbsDownFilled = filled(ThumbsDown);
export const CircleFilled = filled(Circle);
export const PlayFilled = filled(Play);
export const SparkleFilled = filled(Sparkle);
